<template>
  <div class="container mx-auto px-8 pt-16 lg:px-16">
    <h2 class="font-raleway text-4xl font-bold uppercase tracking-wider">
      Comment ça marche ?
    </h2>
    <hr class="border mb-10 border-green-500" />

    <div class="flex flex-col md:flex-row">
      <div class="order-2 m-4 flex flex-col justify-center md:order-1 md:w-1/2">
        <!-- <div
          class="flex px-6 py-2 rounded md:w-full md:py-4"
          v-on:mouseover="disableAutoAnimate(), screenJourney = true"
          v-on:mouseleave="enableAutoAnimate()"
          v-bind:class="{ active: screenJourney }"
          v-if="isGpsEnabled"
        >
          <div class="flex-shrink-0 hidden w-12 h-12 p-3 mr-4 bg-green-500 rounded-full md:block">
            <svgLocation class="text-white fill-current" />
          </div>
          <div>
            <p class="font-medium tracking-wider text-gray-100 uppercase font-raleway">Son trajet</p>
            <p
              class="hidden md:block"
            >Suivez le trajet de votre chat à tout moment, il est désormais impossible de perdre votre compagnon favori !</p>
          </div>
        </div> -->

        <div
          class="rounded flex px-6 py-2 md:w-full md:py-4"
          v-on:mouseover="disableAutoAnimate(), (screenActivity = true)"
          v-on:mouseleave="enableAutoAnimate()"
          v-bind:class="{ active: screenActivity }"
        >
          <div
            class="mr-4 hidden h-12 w-12 flex-shrink-0 rounded-full bg-green-500 p-3 md:block"
          >
            <svgActivity class="fill-current text-white" />
          </div>
          <div>
            <p
              class="font-raleway font-medium uppercase tracking-wider text-gray-100"
            >
              Ses activités
            </p>
            <p class="hidden md:block">
              Le collier catégorise l’activité de votre chat pour s’assurer
              qu’il mène une vie saine.
            </p>
          </div>
        </div>

        <div
          class="rounded flex px-6 py-2 md:w-full md:py-4"
          v-on:mouseover="disableAutoAnimate(), (screenSleep = true)"
          v-on:mouseleave="enableAutoAnimate()"
          v-bind:class="{ active: screenSleep }"
        >
          <div
            class="mr-4 hidden h-12 w-12 flex-shrink-0 rounded-full bg-green-500 p-3 md:block"
          >
            <svgMoon class="fill-current text-white" />
          </div>
          <div>
            <p
              class="font-raleway font-medium uppercase tracking-wider text-gray-100"
            >
              Son sommeil
            </p>
            <p class="hidden md:block">
              HerdingCats mesure le sommeil de votre chat en fonction de sa
              durée et de sa qualité.
            </p>
          </div>
        </div>

        <div
          class="rounded flex px-6 py-2 md:w-full md:py-4"
          v-on:mouseover="disableAutoAnimate(), (screenFriends = true)"
          v-on:mouseleave="enableAutoAnimate()"
          v-bind:class="{ active: screenFriends }"
        >
          <div
            class="mr-4 hidden h-12 w-12 flex-shrink-0 rounded-full bg-green-500 p-3 md:block"
          >
            <svgDroplet class="fill-current text-white" />
          </div>
          <div>
            <p
              class="font-raleway font-medium uppercase tracking-wider text-gray-100"
            >
              Sa toilette
            </p>
            <p class="hidden md:block">
              Le collier suit les habitudes de toilette de votre chat, vous
              aidant à surveiller sa propreté et à détecter d'éventuelles
              anomalies.
            </p>
          </div>
        </div>

        <div
          class="rounded flex px-6 py-2 md:w-full md:py-4"
          v-on:mouseover="disableAutoAnimate(), (screenMaladies = true)"
          v-on:mouseleave="enableAutoAnimate()"
          v-bind:class="{ active: screenMaladies }"
        >
          <div
            class="mr-4 hidden h-12 w-12 flex-shrink-0 rounded-full bg-green-500 p-3 md:block"
          >
            <svgHealth class="fill-current text-white" />
          </div>
          <div>
            <p
              class="font-raleway font-medium uppercase tracking-wider text-gray-100"
            >
              Son état de santé
            </p>
            <p class="hidden md:block">
              Le collier permet grâce au suivi de ses activités de faire de la
              prédiction et d’anticiper la survenue d’éventuelles maladies.
            </p>
          </div>
        </div>
        <p class="mt-4 inline-block px-6 md:hidden">
          Créé par des chercheurs, des ingénieurs et des designers, il permet de
          détecter ses activités durant sa journée. Oui ! Vous saurez enfin ce
          qu’ils font ! Toilettes, bagarres, votre chat est-il un gros feignant
          ? Vous saurez tout !
        </p>
      </div>

      <div class="relative order-1 m-1 md:order-1 md:w-1/2">
        <div
          class="iphone-x-screen"
          v-bind:class="{
            'screen-maladies': screenMaladies,
            'screen-activity': screenActivity,
            'screen-friends': screenFriends,
            'screen-sleep': screenSleep,
          }"
        ></div>
        <div class="iphone-x"></div>
      </div>
    </div>

    <div class="mt-8 text-center">
      <a
        href="#soutenir"
        v-scroll-to="'#soutenir'"
        class="inline-block rounded-full bg-green-500 px-8 py-4 font-bold uppercase tracking-wider text-white shadow-md hover:bg-green-400 hover:shadow-lg"
        >Nous suivre</a
      >
    </div>
  </div>
</template>

<script>
import svgActivity from "../assets/svg/activity-2.svg";
import svgLocation from "../assets/svg/location.svg";
import svgHeart from "../assets/svg/heart.svg";
import svgDroplet from "../assets/svg/droplet.svg";
import svgMoon from "../assets/svg/moon.svg";
import svgHealth from "../assets/svg/health.svg";
import { setTimeout, setInterval } from "timers";

export default {
  name: "Application",
  components: {
    svgActivity,
    svgLocation,
    svgHeart,
    svgDroplet,
    svgMoon,
    svgHealth,
  },
  // props: {
  //   isGpsEnabled: {
  //     default: true,
  //     type: Boolean
  //   }
  // },
  data: function () {
    return {
      screenJourney: false,
      screenFriends: true,
      screenSleep: false,
      screenActivity: false,
      screenMaladies: false,
      screenAutoAnimate: true,
    };
  },
  methods: {
    autoAnimate: function () {
      // if (this.isGpsEnabled == true) {
      if (this.screenAutoAnimate == true) {
        if (this.screenActivity == true) {
          this.screenActivity = false;
          this.screenSleep = true;
        } else if (this.screenSleep == true) {
          this.screenSleep = false;
          this.screenFriends = true;
        } else if (this.screenFriends == true) {
          this.screenFriends = false;
          this.screenMaladies = true;
        } else if (this.screenMaladies == true) {
          this.screenMaladies = false;
          this.screenActivity = true;
        }
      }
    },
    disableAutoAnimate: function () {
      if (this.screenAutoAnimate == true) {
        this.screenAutoAnimate = false;
        this.screenJourney = false;
        this.screenFriends = false;
        this.screenSleep = false;
        this.screenActivity = false;
        this.screenMaladies = false;
      }
    },
    enableAutoAnimate: function () {
      if (this.screenAutoAnimate == false) {
        this.screenAutoAnimate = true;
      }
    },
  },
  mounted: function () {
    window.setInterval(() => {
      this.autoAnimate();
    }, 3000);
  },
};
</script>

<style>
.active {
  background-color: #6b7280;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.iphone-x {
  background-image: url("../assets/img/iphone14.png");
  background-size: cover;
  height: 560px;
  width: 290px;
  margin: auto;
  position: relative;
  opacity: 1;
}

.iphone-x-screen {
  background-image: url("../assets/img/spriteScreens14.jpg");
  background-size: cover;
  position: absolute;
  height: 512px;
  width: 236px;
  top: 32px;
  left: 50%;
  margin-left: -118px;
  transition: background-position 300ms ease-in-out;
}

.screen-activity {
  background-position: 0;
}

.screen-friends {
  background-position: -472px;
}

.screen-sleep {
  background-position: -236px;
}

.screen-maladies {
  background-position: -708px;
}
</style>
